// @ts-strict-ignore
import {ChartType} from 'common/report/constants';
import {BookmarkType} from 'common/report/queries/app-api/bookmark-client';

import BOARDS_IMAGE from './images/color/report-types/boards.svg';
import DEFAULT_IMAGE from './images/color/report-types/default.svg';
import FLOWS_IMAGE from './images/color/report-types/flows.svg';
import FUNNELS_IMAGE from './images/color/report-types/funnels.svg';
import INSIGHTS_IMAGE from './images/color/report-types/insights.svg';
import RETENTION_IMAGE from './images/color/report-types/retention.svg';
import IMPACT_IMAGE from './images/color/report-types/impact.svg';
import FLOWS_SANKEY_IMAGE from './images/color/chart-types/flows-sankey.svg';
import FLOWS_TOP_PATHS_IMAGE from './images/color/chart-types/flows-top-paths.svg';
import FUNNEL_FREQUENCY_IMAGE from './images/color/chart-types/funnel-frequency.svg';
import FUNNEL_STEPS_IMAGE from './images/color/chart-types/funnel-steps.svg';
import FUNNEL_TOP_PATHS_IMAGE from './images/color/chart-types/funnel-top-paths.svg';
import FUNNEL_TRENDS_IMAGE from './images/color/chart-types/funnel-trends.svg';
import FUNNEL_TTC_IMAGE from './images/color/chart-types/funnel-ttc.svg';
import FUNNEL_METRIC_IMAGE from './images/color/chart-types/funnel-metric.svg';
import INSIGHTS_BAR_IMAGE from './images/color/chart-types/insights-bar.svg';
import INSIGHTS_LINE_IMAGE from './images/color/chart-types/insights-line.svg';
import INSIGHTS_METRIC_IMAGE from './images/color/chart-types/insights-metric.svg';
import INSIGHTS_PIE_IMAGE from './images/color/chart-types/insights-pie.svg';
import INSIGHTS_STACKED_BAR_IMAGE from './images/color/chart-types/insights-stacked-bar.svg';
import INSIGHTS_STACKED_LINE_IMAGE from './images/color/chart-types/insights-stacked-line.svg';
import INSIGHTS_TABLE_IMAGE from './images/color/chart-types/insights-table.svg';
import RETENTION_CURVE_IMAGE from './images/color/chart-types/retention-curve.svg';
import RETENTION_TRENDS_IMAGE from './images/color/chart-types/retention-trends.svg';
import RETENTION_METRIC_IMAGE from './images/color/chart-types/retention-metric.svg';
import FLOWS_SANKEY_IMAGE_GRAYSCALE from './images/grayscale/chart-types/flows-sankey.svg';
import FLOWS_TOP_PATHS_IMAGE_GRAYSCALE from './images/grayscale/chart-types/flows-top-paths.svg';
import FUNNEL_FREQUENCY_IMAGE_GRAYSCALE from './images/grayscale/chart-types/funnel-frequency.svg';
import FUNNEL_STEPS_IMAGE_GRAYSCALE from './images/grayscale/chart-types/funnel-steps.svg';
import FUNNEL_TOP_PATHS_IMAGE_GRAYSCALE from './images/grayscale/chart-types/funnel-top-paths.svg';
import FUNNEL_TRENDS_IMAGE_GRAYSCALE from './images/grayscale/chart-types/funnel-trends.svg';
import FUNNEL_TTC_IMAGE_GRAYSCALE from './images/grayscale/chart-types/funnel-ttc.svg';
import INSIGHTS_BAR_IMAGE_GRAYSCALE from './images/grayscale/chart-types/insights-bar.svg';
import INSIGHTS_LINE_IMAGE_GRAYSCALE from './images/grayscale/chart-types/insights-line.svg';
import INSIGHTS_METRIC_IMAGE_GRAYSCALE from './images/grayscale/chart-types/insights-metric.svg';
import INSIGHTS_PIE_IMAGE_GRAYSCALE from './images/grayscale/chart-types/insights-pie.svg';
import INSIGHTS_STACKED_BAR_IMAGE_GRAYSCALE from './images/grayscale/chart-types/insights-stacked-bar.svg';
import INSIGHTS_STACKED_LINE_IMAGE_GRAYSCALE from './images/grayscale/chart-types/insights-stacked-line.svg';
import INSIGHTS_TABLE_IMAGE_GRAYSCALE from './images/grayscale/chart-types/insights-table.svg';
import RETENTION_CURVE_IMAGE_GRAYSCALE from './images/grayscale/chart-types/retention-curve.svg';
import RETENTION_TRENDS_IMAGE_GRAYSCALE from './images/grayscale/chart-types/retention-trends.svg';
import NO_ACCESS_GRAYSCALE from './images/grayscale/no-access.svg';
import FLOWS_SANKEY_IMAGE_HOVERING from './images/hovering/chart-types/flows-sankey.svg';
import FLOWS_TOP_PATHS_IMAGE_HOVERING from './images/hovering/chart-types/flows-top-paths.svg';
import FUNNEL_FREQUENCY_IMAGE_HOVERING from './images/hovering/chart-types/funnel-frequency.svg';
import FUNNEL_STEPS_IMAGE_HOVERING from './images/hovering/chart-types/funnel-steps.svg';
import FUNNEL_TOP_PATHS_IMAGE_HOVERING from './images/hovering/chart-types/funnel-top-paths.svg';
import FUNNEL_TRENDS_IMAGE_HOVERING from './images/hovering/chart-types/funnel-trends.svg';
import FUNNEL_TTC_IMAGE_HOVERING from './images/hovering/chart-types/funnel-ttc.svg';
import INSIGHTS_BAR_IMAGE_HOVERING from './images/hovering/chart-types/insights-bar.svg';
import INSIGHTS_LINE_IMAGE_HOVERING from './images/hovering/chart-types/insights-line.svg';
import INSIGHTS_METRIC_IMAGE_HOVERING from './images/hovering/chart-types/insights-metric.svg';
import INSIGHTS_PIE_IMAGE_HOVERING from './images/hovering/chart-types/insights-pie.svg';
import INSIGHTS_STACKED_BAR_IMAGE_HOVERING from './images/hovering/chart-types/insights-stacked-bar.svg';
import INSIGHTS_STACKED_LINE_IMAGE_HOVERING from './images/hovering/chart-types/insights-stacked-line.svg';
import INSIGHTS_TABLE_IMAGE_HOVERING from './images/hovering/chart-types/insights-table.svg';
import RETENTION_CURVE_IMAGE_HOVERING from './images/hovering/chart-types/retention-curve.svg';
import RETENTION_TRENDS_IMAGE_HOVERING from './images/hovering/chart-types/retention-trends.svg';

export function getDefaultEntityImage(bookmarkType: string = null) {
  switch (bookmarkType) {
    case BookmarkType.Impact:
      return IMPACT_IMAGE;
    case BookmarkType.Funnels:
      return FUNNELS_IMAGE;
    case BookmarkType.Flows:
      return FLOWS_IMAGE;
    case BookmarkType.Insights:
      return INSIGHTS_IMAGE;
    case BookmarkType.Retention:
      return RETENTION_IMAGE;
    case BookmarkType.Dashboard:
      return BOARDS_IMAGE;
    default:
      return DEFAULT_IMAGE;
  }
}

export function getEntityImage(
  chartType: ChartType = null,
  bookmarkType: string = null,
  isGrayscale = false,
  isHovering = false,
  hasNoAccess = false,
) {
  if (isHovering) {
    return getEntityImageHovering(chartType, bookmarkType);
  }

  if (isGrayscale) {
    return getEntityImageGrayscale(chartType, bookmarkType);
  }

  if (hasNoAccess) {
    return NO_ACCESS_GRAYSCALE;
  }

  const LINE_MAPPING = {
    [BookmarkType.Insights]: INSIGHTS_LINE_IMAGE,
    [BookmarkType.Funnels]: FUNNEL_TRENDS_IMAGE,
    [BookmarkType.Retention]: RETENTION_TRENDS_IMAGE,
  };
  const BAR_MAPPING = {
    [BookmarkType.Insights]: INSIGHTS_BAR_IMAGE,
    [BookmarkType.Funnels]: FUNNEL_FREQUENCY_IMAGE,
  };
  const METRIC_MAPPING = {
    [BookmarkType.Insights]: INSIGHTS_METRIC_IMAGE,
    [BookmarkType.Funnels]: FUNNEL_METRIC_IMAGE,
    [BookmarkType.Retention]: RETENTION_METRIC_IMAGE,
  };

  switch (chartType) {
    case ChartType.Flows:
    case ChartType.Sankey:
      return FLOWS_SANKEY_IMAGE;
    case ChartType.FlowsTopPaths:
      return FLOWS_TOP_PATHS_IMAGE;
    case ChartType.FunnelFrequencyBar:
    case ChartType.FunnelFrequencyLine:
      return FUNNEL_FREQUENCY_IMAGE;
    case ChartType.FunnelMedianTTC:
    case ChartType.FunnelTTCBar:
    case ChartType.FunnelTTCLine:
      return FUNNEL_TTC_IMAGE;
    case ChartType.FunnelSteps:
    case ChartType.FunnelStepsMetric:
      return FUNNEL_STEPS_IMAGE;
    case ChartType.FunnelTrend:
      return FUNNEL_TRENDS_IMAGE;
    case ChartType.FunnelTopPaths:
      return FUNNEL_TOP_PATHS_IMAGE;
    case ChartType.Bar:
      return BAR_MAPPING[bookmarkType] || getDefaultEntityImage(bookmarkType);
    case ChartType.Line:
      return LINE_MAPPING[bookmarkType] || getDefaultEntityImage(bookmarkType);
    case ChartType.Table:
      return INSIGHTS_TABLE_IMAGE;
    case ChartType.Metric:
    case ChartType.LegacyMetric:
      return METRIC_MAPPING[bookmarkType] || getDefaultEntityImage(bookmarkType);
    case ChartType.StackedBar:
      return INSIGHTS_STACKED_BAR_IMAGE;
    case ChartType.StackedLine:
      return INSIGHTS_STACKED_LINE_IMAGE;
    case ChartType.Pie:
      return INSIGHTS_PIE_IMAGE;
    case ChartType.RetentionLine:
    case ChartType.RetentionTable:
    case ChartType.RetentionCurve:
      return RETENTION_CURVE_IMAGE;
    case ChartType.RetentionTrend:
    case ChartType.RetentionTrendMetric:
      return RETENTION_TRENDS_IMAGE;
    default:
      return getDefaultEntityImage(bookmarkType);
  }
}

export function getEntityImageGrayscale(chartType: ChartType = null, bookmarkType: string = null) {
  const LINE_MAPPING = {
    [BookmarkType.Insights]: INSIGHTS_LINE_IMAGE_GRAYSCALE,
    [BookmarkType.Funnels]: FUNNEL_TRENDS_IMAGE_GRAYSCALE,
    [BookmarkType.Retention]: RETENTION_TRENDS_IMAGE_GRAYSCALE,
  };
  const BAR_MAPPING = {
    [BookmarkType.Insights]: INSIGHTS_BAR_IMAGE_GRAYSCALE,
    [BookmarkType.Funnels]: FUNNEL_FREQUENCY_IMAGE_GRAYSCALE,
  };
  const METRIC_MAPPING = {
    [BookmarkType.Insights]: INSIGHTS_METRIC_IMAGE_GRAYSCALE,
    [BookmarkType.Funnels]: INSIGHTS_METRIC_IMAGE_GRAYSCALE,
    [BookmarkType.Retention]: INSIGHTS_METRIC_IMAGE_GRAYSCALE,
  };
  switch (chartType) {
    case ChartType.Flows:
    case ChartType.Sankey:
      return FLOWS_SANKEY_IMAGE_GRAYSCALE;
    case ChartType.FlowsTopPaths:
      return FLOWS_TOP_PATHS_IMAGE_GRAYSCALE;
    case ChartType.FunnelFrequencyBar:
    case ChartType.FunnelFrequencyLine:
      return FUNNEL_FREQUENCY_IMAGE_GRAYSCALE;
    case ChartType.FunnelMedianTTC:
    case ChartType.FunnelTTCBar:
    case ChartType.FunnelTTCLine:
      return FUNNEL_TTC_IMAGE_GRAYSCALE;
    case ChartType.FunnelSteps:
    case ChartType.FunnelStepsMetric:
      return FUNNEL_STEPS_IMAGE_GRAYSCALE;
    case ChartType.FunnelTrend:
      return FUNNEL_TRENDS_IMAGE_GRAYSCALE;
    case ChartType.FunnelTopPaths:
      return FUNNEL_TOP_PATHS_IMAGE_GRAYSCALE;
    case ChartType.Bar:
      return BAR_MAPPING[bookmarkType] || getDefaultEntityImage(bookmarkType);
    case ChartType.Line:
      return LINE_MAPPING[bookmarkType] || getDefaultEntityImage(bookmarkType);
    case ChartType.Table:
      return INSIGHTS_TABLE_IMAGE_GRAYSCALE;
    case ChartType.Metric:
    case ChartType.LegacyMetric:
      return METRIC_MAPPING[bookmarkType] || getDefaultEntityImage(bookmarkType);
    case ChartType.StackedBar:
      return INSIGHTS_STACKED_BAR_IMAGE_GRAYSCALE;
    case ChartType.StackedLine:
      return INSIGHTS_STACKED_LINE_IMAGE_GRAYSCALE;
    case ChartType.Pie:
      return INSIGHTS_PIE_IMAGE_GRAYSCALE;
    case ChartType.RetentionLine:
    case ChartType.RetentionTable:
    case ChartType.RetentionCurve:
      return RETENTION_CURVE_IMAGE_GRAYSCALE;
    case ChartType.RetentionTrend:
    case ChartType.RetentionTrendMetric:
      return RETENTION_TRENDS_IMAGE_GRAYSCALE;
    default:
      return getDefaultEntityImage(bookmarkType);
  }
}

export function getEntityImageHovering(chartType: ChartType = null, bookmarkType: string = null) {
  const LINE_MAPPING = {
    [BookmarkType.Insights]: INSIGHTS_LINE_IMAGE_HOVERING,
    [BookmarkType.Funnels]: FUNNEL_TRENDS_IMAGE_HOVERING,
    [BookmarkType.Retention]: RETENTION_TRENDS_IMAGE_HOVERING,
  };
  const BAR_MAPPING = {
    [BookmarkType.Insights]: INSIGHTS_BAR_IMAGE_HOVERING,
    [BookmarkType.Funnels]: FUNNEL_FREQUENCY_IMAGE_HOVERING,
  };
  const METRIC_MAPPING = {
    [BookmarkType.Insights]: INSIGHTS_METRIC_IMAGE_HOVERING,
    [BookmarkType.Funnels]: INSIGHTS_METRIC_IMAGE_HOVERING,
    [BookmarkType.Retention]: INSIGHTS_METRIC_IMAGE_HOVERING,
  };
  switch (chartType) {
    case ChartType.Flows:
    case ChartType.Sankey:
      return FLOWS_SANKEY_IMAGE_HOVERING;
    case ChartType.FlowsTopPaths:
      return FLOWS_TOP_PATHS_IMAGE_HOVERING;
    case ChartType.FunnelFrequencyBar:
    case ChartType.FunnelFrequencyLine:
      return FUNNEL_FREQUENCY_IMAGE_HOVERING;
    case ChartType.FunnelMedianTTC:
    case ChartType.FunnelTTCBar:
    case ChartType.FunnelTTCLine:
      return FUNNEL_TTC_IMAGE_HOVERING;
    case ChartType.FunnelSteps:
    case ChartType.FunnelStepsMetric:
      return FUNNEL_STEPS_IMAGE_HOVERING;
    case ChartType.FunnelTrend:
      return FUNNEL_TRENDS_IMAGE_HOVERING;
    case ChartType.FunnelTopPaths:
      return FUNNEL_TOP_PATHS_IMAGE_HOVERING;
    case ChartType.Bar:
      return BAR_MAPPING[bookmarkType] || getDefaultEntityImage(bookmarkType);
    case ChartType.Line:
      return LINE_MAPPING[bookmarkType] || getDefaultEntityImage(bookmarkType);
    case ChartType.Table:
      return INSIGHTS_TABLE_IMAGE_HOVERING;
    case ChartType.Metric:
    case ChartType.LegacyMetric:
      return METRIC_MAPPING[bookmarkType] || getDefaultEntityImage(bookmarkType);
    case ChartType.StackedBar:
      return INSIGHTS_STACKED_BAR_IMAGE_HOVERING;
    case ChartType.StackedLine:
      return INSIGHTS_STACKED_LINE_IMAGE_HOVERING;
    case ChartType.Pie:
      return INSIGHTS_PIE_IMAGE_HOVERING;
    case ChartType.RetentionLine:
    case ChartType.RetentionTable:
    case ChartType.RetentionCurve:
      return RETENTION_CURVE_IMAGE_HOVERING;
    case ChartType.RetentionTrend:
    case ChartType.RetentionTrendMetric:
      return RETENTION_TRENDS_IMAGE_HOVERING;
    default:
      return getDefaultEntityImage(bookmarkType);
  }
}
